import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import { ClientApi } from "../../../API/ClientApi";
import ElectricMopedIcon from "@mui/icons-material/ElectricMoped";
import LinearProgress from "@mui/material/LinearProgress";
import { Avatar, Badge } from "@mui/material";
import styled from "@emotion/styled";
import { GoogleMapProps } from "react-google-maps";
const containerStyle = {
  width: "100%",
  height: "100%",
};

const center = {
  lat: 28.7136,
  lng: 77.1294,
};

function GoogleMapApi({
  mapProps = {},
  children = <></>,
}: {
  mapProps?: GoogleMapProps;
  children?: React.ReactNode;
}) {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedMarker, setSelectedMarker] = useState<number | null>(null);

  useEffect(() => {
    ClientApi.api.googleMapsOnDutyRiders().then((e) => {
      setData(e);
      setLoading(false);
    });
  }, []);

  const getCustomMarkerIcon = () => {
    const svgContent = `
    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="42" viewBox="0 0 62 42">
  <g id="scooter-delivery" transform="translate(-1 -11)">
    <path id="Path_14359" data-name="Path 14359" d="M6.98,33.98a1.024,1.024,0,0,1-.71-.29L3.29,30.71A.99.99,0,0,1,3,30V26a1,1,0,0,1,2,0v3.59l2.69,2.69a1,1,0,0,1,0,1.41A.982.982,0,0,1,6.98,33.98Z" fill="#575f6b"/>
    <path id="Path_14360" data-name="Path 14360" d="M43,17h3v4H43a2.006,2.006,0,0,1-2-2h0A2.006,2.006,0,0,1,43,17Z" fill="#00cd5b"/>
    <path id="Path_14361" data-name="Path 14361" d="M60.32,43A6.844,6.844,0,0,1,61,46a7,7,0,0,1-14,0,6.844,6.844,0,0,1,.68-3Z" fill="#504254"/>
    <circle id="Ellipse_266" data-name="Ellipse 266" cx="3" cy="3" r="3" transform="translate(51 43)" fill="#fcddad"/>
    <path id="Path_14362" data-name="Path 14362" d="M6.29,48a7,7,0,0,0,13.42,0Z" fill="#504254"/>
    <path id="Path_14363" data-name="Path 14363" d="M63,43H46.8l4.21-4.39A2.013,2.013,0,0,1,52.45,38h1.74a10.15,10.15,0,0,1,2.81.4,10.015,10.015,0,0,1,5,3.35ZM14,26H28a2.006,2.006,0,0,1,2,2v3H12V28A2.006,2.006,0,0,1,14,26Z" fill="#00cd5b"/>
    <path id="Path_14364" data-name="Path 14364" d="M30,29v2H12V28a2.006,2.006,0,0,1,2-2h1v1a2.006,2.006,0,0,0,2,2Z" fill="#00893d"/>
    <path id="Path_14365" data-name="Path 14365" d="M57,38v.4a10.15,10.15,0,0,0-2.81-.4H52.45a2.013,2.013,0,0,0-1.44.61L46.8,43l-3.91,4.08a3.01,3.01,0,0,1-2.17.92H1V43.51a12.043,12.043,0,0,1,.37-2.98,12.257,12.257,0,0,1,8.02-8.66L12,31H30a10.233,10.233,0,0,0-3,7.24V44H40l5.66-5.66A7.985,7.985,0,0,0,48,32.69V22h4.11l.64,7.86a10.173,10.173,0,0,0,2.22,5.6L57,38Z" fill="#fc4847"/>
    <path id="Path_14366" data-name="Path 14366" d="M57,38v.4a10.15,10.15,0,0,0-2.81-.4H52.45a2.013,2.013,0,0,0-1.44.61L46.8,43l-3.91,4.08a3.01,3.01,0,0,1-2.17.92H1V43.51a12.043,12.043,0,0,1,.37-2.98,12.257,12.257,0,0,1,8.02-8.66L12,31H30a10.233,10.233,0,0,0-3,7.24V44H40l5.66-5.66A7.985,7.985,0,0,0,48,32.69V22h4.11l.64,7.86a10.173,10.173,0,0,0,2.22,5.6L57,38Z" fill="#00cd5b"/>
    <path id="Path_14367" data-name="Path 14367" d="M57,38v.4a10.15,10.15,0,0,0-2.81-.4H52.45a2.013,2.013,0,0,0-1.44.61L46.8,43l-3.91,4.08a3.01,3.01,0,0,1-2.17.92H1V43.51a12.043,12.043,0,0,1,.37-2.98,12.206,12.206,0,0,1,6.67-8.11c-.27.23-.52.49-.77.75a12.2,12.2,0,0,0-2.9,5.36A12.043,12.043,0,0,0,4,41.51V44a2.006,2.006,0,0,0,2,2H40.72a3.01,3.01,0,0,0,2.17-.92L46.8,41l4.21-4.39A2.013,2.013,0,0,1,52.45,36h1.74a9.075,9.075,0,0,1,1.28.09L57,38Z" fill="#00893d"/>
    <path id="Path_14368" data-name="Path 14368" d="M13,38h0a8,8,0,0,1,8,8v2H5V46A8,8,0,0,1,13,38Z" fill="#00893d"/>
    <path id="Path_14369" data-name="Path 14369" d="M52,16v6H48a3,3,0,0,1,0-6h4Z" fill="#00cd5b"/>
    <rect id="Rectangle_1708" data-name="Rectangle 1708" width="4" height="6" transform="translate(52 16)" fill="#fcddad"/>
    <rect id="Rectangle_1709" data-name="Rectangle 1709" width="20" height="15" transform="translate(1 11)" fill="#00cd5b"/>
    <path id="Path_14370" data-name="Path 14370" d="M21,24v2H1V11H4v7a6,6,0,0,0,6,6Z" fill="#00893d"/>
    <rect id="Rectangle_1710" data-name="Rectangle 1710" width="6" height="5" transform="translate(8 11)" fill="#fc4847"/>
    <path id="Path_14371" data-name="Path 14371" d="M14,14v2H8V11h2v1a2.006,2.006,0,0,0,2,2Z" fill="#f43737"/>
    <path id="Path_14372" data-name="Path 14372" d="M45.77,19v2H43a2.006,2.006,0,0,1-2-2,2.03,2.03,0,0,1,1.02-1.74A2.005,2.005,0,0,0,44,19Z" fill="#00893d"/>
    <path id="Path_14373" data-name="Path 14373" d="M57.66,51.96A6.889,6.889,0,0,1,54,53a7,7,0,0,1-7-7,6.844,6.844,0,0,1,.68-3h2.61A6.908,6.908,0,0,0,50,45a7,7,0,0,0,7,7A4.872,4.872,0,0,0,57.66,51.96Z" fill="#3e3342"/>
    <path id="Path_14374" data-name="Path 14374" d="M56.98,46.24A2.995,2.995,0,0,1,51,46a2.929,2.929,0,0,1,1.02-2.24A.974.974,0,0,0,52,44a2.989,2.989,0,0,0,4.98,2.24Z" fill="#fcc489"/>
    <path id="Path_14375" data-name="Path 14375" d="M16.65,51.97A7,7,0,0,1,6.29,48H9.67A7,7,0,0,0,16,52C16.22,52,16.44,51.99,16.65,51.97Z" fill="#3e3342"/>
    <path id="Path_14376" data-name="Path 14376" d="M52,20v2H48a3,3,0,0,1-2.12-5.12,3.058,3.058,0,0,1,1.25-.75A3.1,3.1,0,0,0,47,17a3,3,0,0,0,3,3h2Z" fill="#00893d"/>
    <path id="Path_14377" data-name="Path 14377" d="M56,20v2H52V16h2v2A2.006,2.006,0,0,0,56,20Z" fill="#fcc489"/>
    <path id="Path_14378" data-name="Path 14378" d="M63,43H46.8l4.21-4.39A2.013,2.013,0,0,1,52.45,38h.31a2,2,0,0,0,1.73,3h6.84a9.666,9.666,0,0,1,.67.75L63,43ZM21,46v2H5V46a8,8,0,0,1,5.17-7.48A8,8,0,0,0,8,44a2.006,2.006,0,0,0,2,2Z" fill="#00cd5b"/>
  </g>
</svg>
 `;

    const svgIcon = `data:image/svg+xml;base64,${btoa(svgContent)}`;

    return {
      url: svgIcon,
      scaledSize: new window.google.maps.Size(21.5, 21.5),
    };
  };

  const handleMarkerClick = (index: number) => {
    setSelectedMarker(index);
  };
  const dashBoard = window.location.pathname === "/Dashboard";

  const shouldRenderInfoWindow =
    window.location.pathname === "/liveTrackingRider";
  const phone = (
    <svg
      width="16"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.70633 1.34792C2.6145 1.38058 2.46848 1.46865 1.80987 2.16219C1.79105 2.18201 1.77103 2.20065 1.74992 2.21801C1.51123 2.41433 1.36172 2.69799 1.33445 3.00508C1.32977 3.82231 1.54479 4.62599 1.95723 5.33211C1.96546 5.3462 1.97317 5.36058 1.98034 5.37523C2.14457 5.71077 2.33393 6.03342 2.5468 6.3404C2.54945 6.34423 2.55206 6.34808 2.55463 6.35196C3.55404 7.8597 4.9159 9.0932 6.51571 9.93971C6.52364 9.94391 6.53148 9.94826 6.53923 9.95278C7.2199 10.3489 7.97893 10.5916 8.76329 10.6641C9.06339 10.6862 9.36053 10.595 9.59613 10.4092C9.60384 10.4016 9.61277 10.3928 9.62282 10.3829C9.71977 10.2875 9.92112 10.0893 10.136 9.86989L10.1362 9.86962C10.367 9.63414 10.4739 9.52177 10.5351 9.44945C10.5767 9.40042 10.5851 9.38564 10.612 9.33405C10.6152 9.32777 10.6186 9.32155 10.6221 9.31539C10.6796 9.2132 10.6802 9.0885 10.6236 8.98569C10.6183 8.97616 10.6133 8.96652 10.6085 8.95675C10.5888 8.91635 10.587 8.91496 10.5867 8.91458C10.5844 8.91115 10.5713 8.89223 10.5229 8.83901C10.4189 8.72476 10.2281 8.5339 9.8203 8.12665C9.42458 7.7328 9.23031 7.54077 9.1141 7.43537C9.03537 7.36397 9.02516 7.36127 9.01881 7.35959C9.01776 7.35931 9.01681 7.35905 9.01567 7.35852C9.01169 7.35666 9.00774 7.35475 9.0038 7.35281C8.89366 7.29852 8.76482 7.29967 8.65622 7.35452C8.4935 7.48883 8.3381 7.6318 8.19078 7.78276C8.18757 7.78605 8.18433 7.7893 8.18105 7.79252L7.89136 8.07736C7.5771 8.3833 7.10055 8.45049 6.71377 8.24351C6.70563 8.23916 6.69759 8.23463 6.68964 8.22995C5.46212 7.50603 4.43959 6.48153 3.71871 5.25317C3.71228 5.24221 3.70617 5.23107 3.70037 5.21976C3.51826 4.86432 3.58488 4.43249 3.86538 4.14823L3.8681 4.14547L4.16633 3.84676C4.16642 3.84666 4.16652 3.84657 4.16661 3.84648C4.61763 3.39339 4.63703 3.33589 4.6519 3.29184C4.65271 3.28944 4.65351 3.28707 4.65437 3.28468L4.65608 3.27991C4.69168 3.18278 4.68374 3.07507 4.63426 2.98422C4.63111 2.97844 4.62805 2.97262 4.62508 2.96676C4.6198 2.95633 4.61918 2.95551 4.61733 2.95303C4.61706 2.95269 4.61678 2.9523 4.61645 2.95186C4.60875 2.94135 4.58803 2.91508 4.53433 2.85696C4.42395 2.7375 4.22834 2.54099 3.84601 2.16094M2.70633 1.34792C2.78889 1.32882 2.87459 1.32763 2.95762 1.34443C2.97149 1.34866 2.97954 1.35139 2.98486 1.35335C2.99059 1.35547 2.99197 1.35625 2.99226 1.35641C2.99317 1.35687 3.01316 1.36707 3.0693 1.41372C3.19818 1.52081 3.40475 1.72252 3.84601 2.16094M2.34989 0.0633041C2.65262 -0.0162193 2.97022 -0.0209 3.27521 0.0497201C3.28731 0.0525215 3.29933 0.0556597 3.31125 0.059131C3.39087 0.0823134 3.49367 0.114656 3.60852 0.174382C3.72171 0.23324 3.82213 0.305666 3.92276 0.389292C4.10901 0.544056 4.36734 0.799099 4.78711 1.21617C5.16083 1.58766 5.38073 1.80791 5.51497 1.95319C5.65932 2.10941 5.73875 2.21529 5.81116 2.35615C6.03924 2.7808 6.0753 3.28257 5.91005 3.73556C5.777 4.10569 5.552 4.34496 5.11263 4.78633L5.04184 4.85725C5.58608 5.69319 6.30207 6.40442 7.14248 6.94357L7.24009 6.84759C7.43432 6.64895 7.63987 6.46171 7.8556 6.28683C7.87769 6.26892 7.9009 6.25245 7.92509 6.23751C8.42856 5.92645 9.05665 5.89531 9.58833 6.15482C9.73655 6.22483 9.84365 6.29686 10.0112 6.44883C10.1565 6.58059 10.3788 6.8011 10.7628 7.18332L10.7637 7.18413L10.79 7.21042C11.1664 7.58631 11.3817 7.80138 11.5103 7.94261C11.6667 8.11451 11.7318 8.21866 11.8011 8.35877C12.0698 8.85898 12.0661 9.46153 11.7908 9.95849C11.6502 10.2257 11.524 10.3588 11.0898 10.8018L10.6133 10.336L11.0901 10.8015C11.09 10.8016 11.0899 10.8017 11.0898 10.8018C10.8605 11.0361 10.6337 11.2592 10.5475 11.3439C10.5301 11.361 10.5184 11.3725 10.5137 11.3773C10.4988 11.3921 10.4832 11.4063 10.4669 11.4197C9.96045 11.8378 9.31118 12.0431 8.65605 11.9924L8.6467 11.9917C7.67103 11.9024 6.72667 11.6019 5.87924 11.1111C5.88316 11.1132 5.88707 11.1152 5.89099 11.1173L6.20335 10.5285L5.86746 11.1042C5.87139 11.1065 5.87531 11.1088 5.87924 11.1111C4.08949 10.1615 2.56553 8.78053 1.44581 7.09337C1.44714 7.09529 1.44847 7.09721 1.4498 7.09914L1.9983 6.71977L1.44197 7.08758C1.44325 7.08951 1.44453 7.09144 1.44581 7.09337C1.20088 6.73955 0.982421 6.36815 0.792202 5.98223C0.796328 5.98936 0.80047 5.99649 0.804627 6.00361L1.38093 5.66786L0.781522 5.96049C0.785072 5.96774 0.788632 5.97499 0.792202 5.98223C0.262718 5.06694 -0.0108552 4.02619 0.000329717 2.96886C0.000474206 2.9552 0.00103944 2.94154 0.00202448 2.92792C0.0499807 2.26452 0.36224 1.64868 0.867821 1.21762C0.859161 1.22672 0.850449 1.23589 0.841684 1.24512L1.32578 1.70366L0.901634 1.1893C0.890269 1.19865 0.878998 1.20809 0.867821 1.21762C1.49206 0.561138 1.84352 0.224581 2.31575 0.0732483C2.32704 0.0696313 2.33842 0.0663154 2.34989 0.0633041Z"
        fill="#FF725E"
      />
    </svg>
  );

  const Ev = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00054 15.6841C12.1967 15.6841 15.6847 12.2036 15.6847 7.99996C15.6847 3.80381 12.1892 0.315796 7.99302 0.315796C3.78931 0.315796 0.316406 3.80381 0.316406 7.99996C0.316406 12.2036 3.79687 15.6841 8.00054 15.6841ZM8.00054 14.4034C4.44474 14.4034 1.6046 11.5558 1.6046 7.99996C1.6046 4.45168 4.43722 1.5965 7.99302 1.5965C11.5413 1.5965 14.3965 4.45168 14.404 7.99996C14.4116 11.5558 11.5488 14.4034 8.00054 14.4034ZM7.05133 12.6255L11.0667 7.52534C11.3831 7.12606 11.2399 6.80213 10.8331 6.80213H8.79158L9.37163 3.6682C9.44697 3.23128 8.9799 3.02785 8.69364 3.38194L4.68581 8.48211C4.36187 8.88138 4.50501 9.21284 4.91936 9.21284H6.95339L6.38086 12.3468C6.29797 12.7837 6.76507 12.9871 7.05133 12.6255Z"
        fill="#00CD5B"
      />
    </svg>
  );

  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      backgroundColor: "#44b700",
      color: "#44b700",
      "&::after": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        animation: "ripple 1.2s infinite ease-in-out",
        border: "1px solid currentColor",
        content: '""',
      },
    },
    "@keyframes ripple": {
      "0%": {
        transform: "scale(.8)",
        opacity: 1,
      },
      "100%": {
        transform: "scale(2.4)",
        opacity: 0,
      },
    },
  }));
  return (
    <>
      {data ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={12}
          {...mapProps}
        >
          {data.map((item, index) => (
            <Marker
              key={index}
              position={{
                lat: parseFloat(item.latitude),
                lng: parseFloat(item.longitude),
              }}
              icon={getCustomMarkerIcon()}
              onClick={() => handleMarkerClick(index)}
            />
          ))}
          <div>
            {/* Conditionally render the InfoWindow */}
            {shouldRenderInfoWindow && selectedMarker !== null && (
              <InfoWindow
                position={{
                  lat: parseFloat(data[selectedMarker].latitude),
                  lng: parseFloat(data[selectedMarker].longitude),
                }}
                onCloseClick={() => setSelectedMarker(null)}
              >
                <div className="flex items-center">
                  <div className=" mr-2">
                    <StyledBadge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      variant="dot"
                    >
                      <Avatar>{data[selectedMarker].name.charAt(0)}</Avatar>
                    </StyledBadge>
                  </div>
                  <div>
                    <p className="font-bold text-left text-slate-700">
                      <b>{data[selectedMarker].name}</b>
                    </p>
                    <p className="font-medium	text-left text-slate-700 flex items-center mt-2">
                      <span className="mr-2">{phone} </span>
                      {data[selectedMarker].mobile}
                    </p>
                    <p className="font-medium text-slate-700 flex items-center mt-1">
                      <span className="mr-2">{Ev} </span>
                      {data[selectedMarker].qrCode}
                    </p>
                    <div className="flex border	border-slate-800	p-1 px-2 rounded-lg  mt-1 justify-between">
                      <p className="mr-1">status</p>
                      <p className="font-medium flex items-center d-block">
                        <span className="w-2 h-2 rounded-full bg-green-500 mr-1"></span>{" "}
                        Available
                      </p>
                    </div>
                  </div>
                </div>
              </InfoWindow>
            )}
          </div>
          {dashBoard && selectedMarker !== null && (
            <InfoWindow
              position={{
                lat: parseFloat(data[selectedMarker].latitude),
                lng: parseFloat(data[selectedMarker].longitude),
              }}
              onCloseClick={() => setSelectedMarker(null)} // Add this line to close the InfoWindow
            >
              <div>
                <p className="font-bold">
                  <b>{data[selectedMarker].qrCode}</b>
                </p>
                <p className="font-bold">
                  Client ID:
                  <b>{data[selectedMarker].clientUserId}</b>
                </p>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      ) : (
        <div className="w-full">
          <LinearProgress
            sx={{
              backgroundColor: "white",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#00CD5B",
              },
            }}
          />
        </div>
      )}
    </>
  );
}

export default GoogleMapApi;
